import { Injectable } from '@angular/core';

@Injectable()
export class Config {
  applicationTitle = 'Linnks';
  defaultApplication = 'centralweb';
  crowdAuth = false;
  uniqueLogin = false;
  useSocket = true;

  navigationTimeout: any = null; // TODO: Fix active menu on redirect

  datatableTop = 50;
  autoEdit = true;

  apiUrls: Object = {
    'proof': 'https://dev-centralweb.octalink.com.br/proof',
    'auditor': 'https://dev-centralweb.octalink.com.br',
    'centralweb': 'https://dev-centralweb.octalink.com.br/centralweb'
  };

  apiTestsUrls: Object = {
    'proof': 'https://hml-centralweb.octalink.com.br/proof',
    'auditor': 'https://hml-centralweb.octalink.com.br',
    'centralweb': 'https://hml-centralweb.octalink.com.br/centralweb'
  };

  apiProductionUrls: Object = {
    'proof': 'https://api.linnks.com.br/proof',
    'auditor': 'https://api.linnks.com.br',
    'centralweb': 'https://api.linnks.com.br/centralweb'
  };

  applicationConfig = {
    rowsPerPage: [5, 10, 15, 20, 50],
    rowsPerPageLarge: [15, 20, 25, 30, 50],
    rowsPerPageXLarge: [25, 50, 100],
    rows: 15,
    rows50: 50,
    rowsLarge: 15,
    pageLinks: 5,
    pageLinksLarge: 5,
    testsEnvironment: true
  };

  wsUrl = 'wss://dev-centralweb.linnks.com.br';
  wsTestUrl = 'wss://hml-centralweb.octalink.com.br';
  wsProductionUrl = 'wss://api.linnks.com.br';

  tests = false;

  constructor() {
    try {
      if (window.location.hostname.search('app2') != -1) {
        this.tests = true;
      }
    } catch (exception) {

    }
  }
}
